import makeStyles from '@mui/styles/makeStyles';

const useEnergyGraphContainerStyles = makeStyles({
  root: {}
});

export default useEnergyGraphContainerStyles;
